var _g, _circle, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7523_5999)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.666 12C14.9921 12 16.2639 12.5268 17.2015 13.4645C18.1392 14.4021 18.666 15.6739 18.666 17C18.666 18.3261 18.1392 19.5979 17.2015 20.5355C16.2639 21.4732 14.9921 22 13.666 22C12.3399 22 11.0682 21.4732 10.1305 20.5355C9.1928 19.5979 8.66602 18.3261 8.66602 17C8.66602 15.6739 9.1928 14.4021 10.1305 13.4645C11.0682 12.5268 12.3399 12 13.666 12ZM21.166 12.8333C22.416 12.8333 23.2493 14.6992 23.2493 17C23.2493 19.3008 22.416 21.1667 21.166 21.1667C19.916 21.1667 19.0827 19.3008 19.0827 17C19.0827 14.6992 19.916 12.8333 21.166 12.8333ZM24.4993 13.25C24.816 13.25 25.0927 13.9392 25.2327 15.1217L25.2718 15.4908L25.2877 15.6867L25.3127 16.0983L25.321 16.3142L25.331 16.765L25.3327 17L25.331 17.235L25.321 17.6858L25.3127 17.9025L25.2877 18.3133L25.271 18.5092L25.2335 18.8783C25.0927 20.0617 24.8168 20.75 24.4993 20.75C24.1827 20.75 23.906 20.0608 23.766 18.8783L23.7268 18.5092C23.7211 18.4439 23.7158 18.3786 23.711 18.3133L23.686 17.9017C23.6828 17.8297 23.68 17.7578 23.6777 17.6858L23.6677 17.235V16.765L23.6777 16.3142L23.686 16.0975L23.711 15.6867L23.7277 15.4908L23.7652 15.1217C23.906 13.9383 24.1818 13.25 24.4993 13.25ZM13.666 13.6667C12.782 13.6667 11.9341 14.0179 11.309 14.643C10.6839 15.2681 10.3327 16.1159 10.3327 17C10.3327 17.8841 10.6839 18.7319 11.309 19.357C11.9341 19.9821 12.782 20.3333 13.666 20.3333C14.5501 20.3333 15.3979 19.9821 16.023 19.357C16.6482 18.7319 16.9993 17.8841 16.9993 17C16.9993 16.1159 16.6482 15.2681 16.023 14.643C15.3979 14.0179 14.5501 13.6667 13.666 13.6667ZM21.1293 14.8358C20.8268 15.5025 20.7493 16.2783 20.7493 17C20.7493 17.7217 20.826 18.4983 21.1293 19.1642C21.1443 19.1958 21.1877 19.1958 21.2027 19.1642C21.5052 18.4975 21.5827 17.7217 21.5827 17C21.5827 16.2783 21.506 15.5017 21.2027 14.8358C21.1996 14.8287 21.1944 14.8226 21.1879 14.8184C21.1814 14.8141 21.1738 14.8118 21.166 14.8118C21.1582 14.8118 21.1506 14.8141 21.1441 14.8184C21.1376 14.8226 21.1325 14.8287 21.1293 14.8358Z",
    fill: "#8E8E8E"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8471,
    cy: 16.5385,
    r: 16.5385,
    fill: "#6C6C6C",
    fillOpacity: 0.39
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8471,
    cy: 16.5385,
    r: 16.125,
    stroke: "#8E8E8E",
    strokeOpacity: 0.31,
    strokeWidth: 0.826923
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7523_5999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMing);
export default __webpack_public_path__ + "static/media/ming.e14816e2de8200d69995fefcc4ece450.svg";
export { ForwardRef as ReactComponent };